<template>
  <div class="wrap">
    <div class="main_con fadeInUp animated">
      <div class="breadcrumb_con">
        <el-breadcrumb separator="/">
          <i class="el-icon-location-outline left icon-location"></i>
          <span class="left">{{ $t("common.CurrentLocation") }}：</span>
          <el-breadcrumb-item
            ><router-link to="/Home">{{
              $t("common.Glang")
            }}</router-link></el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ $t("top.Products") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-divider></el-divider>
      <img
        class="header_img"
        v-if="head_img"
        :src="img_head_url + head_img.src"
      />
      <div class="body_con">
        <div class="type_con">
          <ul class="flex-display flex-wrap">
            <li
              :class="categories_id == 0 ? 'active' : ''"
              @click="changeId(0)"
            >
              <a href="javaScript:;">{{ $t("products.AllProducts") }}</a>
            </li>
            <li
              v-for="(item, index) in categoriesList"
              :key="'categoriesList' + index"
              :class="item.id == categories_id ? 'active' : ''"
              @click="changeId(item.id)"
            >
              <a href="javaScript:;"> {{ item.title }}</a>
            </li>
          </ul>
        </div>
        <div class="products_con">
          <el-row :gutter="20">
            <el-col
              :span="6"
              v-for="(item, index) in productList"
              :key="'productList' + index"
            >
              <router-link :to="'/ProductDetail?id=' + item.id">
                <el-card class="card_con">
                  <div class="type_name">{{ item.categories_name }}</div>
                  <div class="products_name">{{ item.title }}</div>
                  <div class="products_pic">
                    <img class="img" :src="img_head_url + item.src" />
                  </div>
                </el-card>
              </router-link>
            </el-col>
          </el-row>
        </div>
        <el-pagination
          style="margin: 20px 0; text-align: center"
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-size="limit"
          :total="count"
          background
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // 监听,当路由发生变化的时候执行
  watch: {
    $route (to, from) {
      var that = this
      console.log(to.query.id)
      that.categories_id = to.query.id || 0
    }
  },
  components: {},
  data () {
    return {
      loading: true,
      categoriesList: [],
      productList: [],
      chooseIndex: 0,
      page: 1,
      limit: 12,
      count: 0,
      categories_id: 0,
      img_head_url: '',
      head_img: '',
      lang: localStorage.lang || 'cn'
    }
  },
  created () {
    console.log(this.$route)
    var that = this
    console.log('created')
    that.categories_id = that.$route.query.id || 0
    this.getCategoriesList()
    this.getProductData()
  },
  methods: {
    changeId (id) {
      var that = this
      that.page = 1
      that.categories_id = id
      that.getProductData()
    },
    getCategoriesList () {
      var that = this
      var json = {
        lang: that.lang
      }
      var url = '/api/get_product_categories'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log(res)
        if (res.meta.status === 200) {
          that.categoriesList = res.data
        }
      })
    },
    getProductData () {
      console.log(1)
      this.loading = true
      var that = this
      var json = {
        categories_id: that.categories_id,
        page: that.page,
        lang: that.lang
      }
      var url = '/api/get_product_list'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log(res)
        if (res.meta.status === 200) {
          that.productList = res.data.product.list
          that.count = res.data.product.count
          that.page = res.data.product.page
          that.head_img = res.data.head_img
          that.img_head_url = res.img_head_url
        }
      })
    },
    imgSrc (src) {
      var that = this
      return that.img_head_url + src
    },
    handleCurrentChange (val) {
      this.page = val
      this.getProductData()
    },
    gotoDetail (id) {
      this.$router.push({ path: '/ProductDetail', query: { id: id } })
    }
  },
  mounted () {}
}
</script>
<style lang="less" scoped>
.type_con {
  width: 1200px;
  margin: 20px auto 20px;
  position: relative;
  text-align: left;
  background-color: #f6f9fb;
}
.type_con li a {
  height: 80px;
  display: inline-block;
  line-height: 80px;
  margin: 0 15px;
  padding: 0 10px;
  font-size: 16px;
  color: inherit;
  position: relative;
}
.type_con li:hover a,
.type_con li.active a {
  color: #3c427c;
}

.type_con li a::after {
  display: block;
  content: "";
  width: 100%;
  height: 2px;
  background-color: #3c427c;
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0;
}

.type_con li:hover a::after,
.type_con li.active a::after {
  opacity: 1;
}
.products_con {
  width: 1200px;
  margin: 20px auto 20px;
  position: relative;
  text-align: left;
}
.products_con .el-col {
  margin-bottom: 20px;
}
.products_con .card_con:hover {
  background-color: rgba( 60, 66, 124, 0.7);
}
.products_con .type_name {
  font-size: 12px;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.products_con .card_con:hover .type_name {
  color: #fff;
}
.products_con .products_name {
  font-size: 14px;
  color: #000;
  margin-bottom: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.products_con .card_con:hover .products_name {
  color: #fff;
}
.products_con .products_pic {
  height: 300px;
}
.products_con .products_pic .img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 100%;
  vertical-align: top;
  border: 0;
}
.el-pagination {
  text-align: center;
}
</style>
